import { gql } from '@apollo/client';

export const MARK_AFFILIATE_COMMISSIONS_PAID = gql`
  mutation MarkAffiliateCommissionsPaid(
    $input: MarkAffiliateCommissionsPaidInput!
  ) {
    markAffiliateCommissionsPaid(input: $input)
  }
`;

export const SET_STREAM_AFFILIATE_LINK_STATUS = gql`
  mutation SetStreamAffiliateLinkStatus(
    $input: SetStreamAffiliateLinkStatusInput!
  ) {
    setStreamAffiliateLinkStatus(input: $input) {
      id
      status
    }
  }
`;
